import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TPatchCompanyTeamMemberStatusResponse = {
  readonly modifiedCount: number;
};

export const patchCompanyTeamMemberStatus = (axios: IAxiosInstance) => {
  return async (options: {
    readonly companyId: string;
    readonly memberUserId: string;
    readonly status: "active" | "deactivated";
  }) => {
    const { data } = await axios.noRetry.patch<
      IApiResponse<TPatchCompanyTeamMemberStatusResponse>
    >(`/api/companies/${options.companyId}/team-members/member-status`, {
      memberUserId: options.memberUserId,
      status: options.status,
    });

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to update team member status");
  };
};
